import { render } from "./RouteNotFoundView.vue?vue&type=template&id=08208036&ts=true"
import script from "./RouteNotFoundView.vue?vue&type=script&lang=ts"
export * from "./RouteNotFoundView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__